export default __webpack_public_path__ + "static/2-deb7cede8b04670afd07b2a98bbd15f9.png";